<template>
  <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
    <div class="border-b-2 border-solid border-[#2463eb] pb-[8px]">
      <h2 class="text-[#2463eb] text-[14px] leading-[20px] font-semibold">
        Sales Reports
      </h2>
    </div>
    <div
      class="border-[1.5px] border-solid border-[#DBDCE0] rounded-[4px] w-full"
    >
      <div class="bg-[#FBFBFB] w-full px-[24px] py-[13px]">
        <p class="text-[#353535] text-[12px] leading-[18px] font-medium">
          List Of All Reports
        </p>
      </div>
      <div class="w-full bg-white flex flex-col justify-start">
        <Dropdown
          v-for="(dropdown, index) in dropdowns"
          :key="index"
          :title="dropdown.title"
          :description="dropdown.description"
          :items="dropdown.items"
          :open="dropdownState[dropdown.key]"
          @toggle="toggleDropdown(dropdown.key)"
          @viewItem="handleAction"
        />
      </div>
    </div>
    <component
      v-for="(modal, index) in visibleModals"
      :key="index"
      :is="modal.component"
      :close="() => toggleModal(modal.name)"
    />
  </div>
</template>

<script>
import Dropdown from "../components/Reports/Dropdown.vue";
import orderDetails from "../components/DistributorReports/orderDetails.vue";
import ActiveOrderCustomer from "../components/DistributorReports/ActiveOrderCustomer.vue";
import ActiveOrderCustomerByStatus from "../components/DistributorReports/ActiveOrderCustomerByStatus.vue";
import volumeProductCategoryReport from "../components/DistributorReports/volumeProductCategoryReport.vue";
import volumeByCustomer from "../components/DistributorReports/volumeByCustomer.vue";
import volumeByProductReport from "../components/DistributorReports/volumeByProductReport.vue";
import StockPurchaseAll from "../components/DistributorReports/StockPurchaseAll.vue";
import StockPurchaseConsolidated from "../components/DistributorReports/StockPurchaseConsolidated.vue";
import stockTransferReport from "../components/DistributorReports/stockTransferReport.vue";
import inventoryByProductCategory from "../components/DistributorReports/inventoryByProductCategory.vue";
import inventoryByProduct from "../components/DistributorReports/inventoryByProduct.vue";
import inventoryByBatchReport from "../components/DistributorReports/inventoryByBatchReport.vue";
import inventoryByWarehousereport from "../components/DistributorReports/inventoryByWarehousereport.vue";
import reconciliationByStatusReport from "../components/DistributorReports/reconciliationByStatusReport.vue";
import reconciliationByOrderNumber from "../components/DistributorReports/reconciliationByOrderNumber.vue";
import salesOrderStatus from "../components/DistributorReports/salesOrderStatus.vue";
import avgMonthlySalesByIntroducer from "../components/DistributorReports/avgMonthlySalesByIntroducer.vue";
import salesMarginReport from "../components/DistributorReports/salesMarginReport.vue";
import stockIssuedSalesReport from "../components/DistributorReports/stockIssuedSalesReport.vue";
import ActiveCashCollectionBranch from "../components/DistributorReports/ActiveCashCollectionBranch.vue";
import totalSalesCollectionsYTD from "../components/DistributorReports/totalSalesCollectionsYTD.vue";
import activeCashCreditRatioGrp from "../components/DistributorReports/activeCashCreditRatioGrp.vue";
import productPerformanceByPercentage from "../components/DistributorReports/productPerformanceByPercentage.vue";
import myCustomerReport from "../components/DistributorReports/myCustomerReport.vue";
export default {
  components: {
    Dropdown,
    orderDetails,
    ActiveOrderCustomer,
    ActiveOrderCustomerByStatus,
    volumeProductCategoryReport,
    volumeByCustomer,
    volumeByProductReport,
    StockPurchaseAll,
    StockPurchaseConsolidated,
    stockTransferReport,
    inventoryByProductCategory,
    inventoryByProduct,
    inventoryByBatchReport,
    inventoryByWarehousereport,
    reconciliationByStatusReport,
    reconciliationByOrderNumber,
    salesOrderStatus,
    avgMonthlySalesByIntroducer,
    salesMarginReport,
    stockIssuedSalesReport,
    ActiveCashCollectionBranch,
    totalSalesCollectionsYTD,
    activeCashCreditRatioGrp,
    productPerformanceByPercentage,
    myCustomerReport,
  },
  data() {
    return {
      modals: {
        orderDetails: false,
        ActiveOrderCustomer: false,
        ActiveOrderCustomerByStatus: false,
        volumeProductCategoryReport: false,
        volumeByCustomer: false,
        volumeByProductReport: false,
        StockPurchaseAll: false,
        StockPurchaseConsolidated: false,
        stockTransferReport: false,
        inventoryByProductCategory: false,
        inventoryByProduct: false,
        inventoryByBatchReport: false,
        inventoryByWarehousereport: false,
        reconciliationByStatusReport: false,
        reconciliationByOrderNumber: false,
        salesOrderStatus: false,
        avgMonthlySalesByIntroducer: false,
        salesMarginReport: false,
        stockIssuedSalesReport: false,
        ActiveCashCollectionBranch: false,
        totalSalesCollectionsYTD: false,
        activeCashCreditRatioGrp: false,
        productPerformanceByPercentage: false,
        myCustomerReport: false,
      },
      dropdownState: {
        orders: false,
        inventory: false,
        sales: false,
        payment: false,
        store: false,
        metrics: false,
        customer: false,
      },
      dropdowns: [
        {
          key: "orders",
          title: "Order Reports",
          description: "View all order details",
          items: [
            { label: "Order Details", action: "orderDetails" },
            { label: "Active order(Customer)", action: "ActiveOrderCustomer" },
            {
              label: "Active order(Customer) (Order Status)",
              action: "ActiveOrderCustomerByStatus",
            },
            {
              label: "Volume By Category",
              action: "volumeProductCategoryReport",
            },
            { label: "Volume By Customer", action: "volumeByCustomer" },
            { label: "Volume By Product", action: "volumeByProductReport" },
          ],
        },
        {
          key: "inventory",
          title: "Inventory Reports",
          description: "View all inventory details",
          items: [
            { label: "Stock Purchase (All)", action: "StockPurchaseAll" },
            {
              label: "Stock Purchase (Consolidated)",
              action: "StockPurchaseConsolidated",
            },
            { label: "Stock Transfer Report", action: "stockTransferReport" },
            {
              label: "Inventory By Category",
              action: "inventoryByProductCategory",
            },
            { label: "Inventory By Product", action: "inventoryByProduct" },
            {
              label: "Inventory By Product Batch",
              action: "inventoryByBatchReport",
            },
            {
              label: "Inventory By Warehouse",
              action: "inventoryByWarehousereport",
            },
            {
              label: "Reconciliation (Product)",
              action: "reconciliationByStatusReport",
            },
            {
              label: "Reconciliation (Order Number)",
              action: "reconciliationByOrderNumber",
            },
          ],
        },
        {
          key: "sales",
          title: "Sales Reports",
          description: "View all sales details",
          items: [
            { label: "Sales By Order Status", action: "salesOrderStatus" },
            {
              label: "Monthly Sales (Sales Agent)",
              action: "avgMonthlySalesByIntroducer",
            },
            { label: "Sales Margins", action: "salesMarginReport" },
            {
              label: "Stock Issued Sales Report",
              action: "stockIssuedSalesReport",
            },
          ],
        },
        {
          key: "payment",
          title: "Payments Reports",
          description: "View all payment details",
          items: [
            {
              label: "Active Cash Collections (Branch)",
              action: "ActiveCashCollectionBranch",
            },
            {
              label: "Total Payment Collection - YTD",
              action: "totalSalesCollectionsYTD",
            },
          ],
        },
        {
          key: "store",
          title: "Store Credit Reports",
          description: "View all store credits details",
          items: [
            {
              label: "Active Cash Credit (Customer)",
              action: "activeCashCreditRatioGrp",
            },
          ],
        },
        {
          key: "metrics",
          title: "Metrics Reports",
          description: "View all store credits details",
          items: [
            {
              label: "Product Performance By Percentage",
              action: "productPerformanceByPercentage",
            },
          ],
        },
        {
          key: "customer",
          title: "Customer Reports",
          description: "View all store customer details",
          items: [{ label: "My Customers", action: "myCustomerReport" }],
        },
      ],
      modalsConfig: {
        orderDetails: { component: "orderDetails" },
        ActiveOrderCustomer: { component: "ActiveOrderCustomer" },
        ActiveOrderCustomerByStatus: {
          component: "ActiveOrderCustomerByStatus",
        },
        volumeProductCategoryReport: {
          component: "volumeProductCategoryReport",
        },
        volumeByCustomer: {
          component: "volumeByCustomer",
        },
        volumeByProductReport: {
          component: "volumeByProductReport",
        },
        StockPurchaseAll: {
          component: "StockPurchaseAll",
        },
        StockPurchaseConsolidated: {
          component: "StockPurchaseConsolidated",
        },
        stockTransferReport: {
          component: "stockTransferReport",
        },
        inventoryByProductCategory: {
          component: "inventoryByProductCategory",
        },
        inventoryByProduct: {
          component: "inventoryByProduct",
        },
        inventoryByBatchReport: {
          component: "inventoryByBatchReport",
        },
        inventoryByWarehousereport: {
          component: "inventoryByWarehousereport",
        },
        reconciliationByStatusReport: {
          component: "reconciliationByStatusReport",
        },
        reconciliationByOrderNumber: {
          component: "reconciliationByOrderNumber",
        },
        salesOrderStatus: {
          component: "salesOrderStatus",
        },
        avgMonthlySalesByIntroducer: {
          component: "avgMonthlySalesByIntroducer",
        },
        salesMarginReport: {
          component: "salesMarginReport",
        },
        stockIssuedSalesReport: {
          component: "stockIssuedSalesReport",
        },
        ActiveCashCollectionBranch: {
          component: "ActiveCashCollectionBranch",
        },
        totalSalesCollectionsYTD: {
          component: "totalSalesCollectionsYTD",
        },
        activeCashCreditRatioGrp: {
          component: "activeCashCreditRatioGrp",
        },
        productPerformanceByPercentage: {
          component: "productPerformanceByPercentage",
        },
        myCustomerReport: {
          component: "myCustomerReport",
        },
      },
    };
  },
  computed: {
    visibleModals() {
      return Object.entries(this.modals)
        .filter(([_, isVisible]) => isVisible)
        .map(([name]) => ({
          name,
          component: this.modalsConfig[name].component,
        }));
    },
  },
  methods: {
    toggleDropdown(key) {
      Object.keys(this.dropdownState).forEach((dropdownKey) => {
        if (dropdownKey !== key) {
          this.dropdownState[dropdownKey] = false;
        }
      });
      this.dropdownState[key] = !this.dropdownState[key];
    },
    toggleModal(modal) {
      this.modals[modal] = !this.modals[modal];
    },
    handleAction(item) {
      if (item && item.action) {
        this.toggleModal(item.action);
      }
      return;
    },
  },
};
</script>
